/**
 * PDBOX otevírané při načtení stránky
 */
$(function() {
	let $pdboxOnLoadQueue = $('.js-pdbox--show-on-load');
	const pdboxOnLoadOpen = function() {
		if ($pdboxOnLoadQueue.length === 0) {
			return;
		}

		const pdBox = window.pdBox || initializePdBox();

		// První element na řadě
		const $el = $pdboxOnLoadQueue.first();
		const delay = $el.data('pdbox-delay') || 0;

		// Odebereme první element z fronty
		$pdboxOnLoadQueue = $pdboxOnLoadQueue.slice(1);

		// Otevřeme s případným zpožděním
		setTimeout(function() {
			// Pokud jde o odkaz na otevření, klikneme
			if ($el.hasClass('js-pdbox')) {
				$el.trigger('click');
			}

			// Pokud jde o již vygenerované HTML pro pdbox, otevřeme přímo tento kód
			else {
				$el
					.detach()
					.removeClass('js-hide u-hidden');

				pdBox?.box && pdBox.box.openHtml($el, $el);
			}
		}, delay);
	};
	pdBox.openNextOnLoad = pdboxOnLoadOpen;

	$pdboxOnLoadQueue.each(function(i) {
		const $el = $(this);
		const onAfterClose = $el.attr('data-pdbox-on-after-close');

		$el.attr('data-pdbox-on-after-close', (onAfterClose ? onAfterClose + ' ' : '') + 'pdBox.openNextOnLoad');
	});

	if ($('.js-cookie-consent').length) {
		document.addEventListener('cookieConsentAfterClose', pdboxOnLoadOpen);
	} else {
		pdboxOnLoadOpen();
	}
});
